import doctor1 from '../assets/images/docter-1.png';
import doctor2 from '../assets/images/docter-2.png';
import doctor3 from '../assets/images/docter-3.png';

export const internationalDoctors = [
  { id: 1, avatar: doctor1, name: 'Dr. Dominic Stonehart' },
  { id: 2, avatar: doctor2, name: 'Dr. Dominic Stonehart' },
  { id: 3, avatar: doctor3, name: 'Dr. Dominic Stonehart' },
  { id: 4, avatar: doctor1, name: 'Dr. Dominic Stonehart' },
  { id: 5, avatar: doctor2, name: 'Dr. Dominic Stonehart' },
  { id: 6, avatar: doctor3, name: 'Dr. Dominic Stonehart' },
  { id: 7, avatar: doctor1, name: 'Dr. Dominic Stonehart' },
  { id: 8, avatar: doctor2, name: 'Dr. Dominic Stonehart' },
  { id: 9, avatar: doctor3, name: 'Dr. Dominic Stonehart' },
];
